export default __webpack_public_path__ + "media/icons/partner-logo-google-cd0f2b38.svg";